import { Badge } from '../../Badge';

const mAndAIconStyles = {
  badge: {
    position: 'relative',
    display: 'inline-flex',
    marginLeft: '0.375rem',
    marginTop: '-0.175rem',
    alignSelf: 'flex-start',
  },
};

type MAndAIconProps = {
  enabled?: boolean;
};

export const MAndAIcon = ({ enabled }: MAndAIconProps) => {
  if (!enabled) {
    return null;
  }

  return (
    <Badge data-id='ma-icon' component='span' variant='ma' sx={mAndAIconStyles.badge}>
      M&A
    </Badge>
  );
};
